export default __webpack_public_path__ + "static/media/05.506f71d3.jpg";